import { formatAmpersand } from '../utils/formatAmpersand';

export const formatHomePagePayload = (homePagePayload) => {
  try {
    const updatedHeroList = (homePagePayload.hero ?? []).map((item) => ({
      ...item,
      name: formatAmpersand(item.name),
    }));
    const updatedCuratedVenues = Object.fromEntries(
      Object.entries(homePagePayload.curatedVenues ?? {}).map(
        ([groupKey, items]) => {
          const formattedItems = (items ?? []).map((item) => ({
            ...item,
            name: formatAmpersand(item?.name ?? ''),
          }));

          return [groupKey, formattedItems];
        }
      )
    );
    let updatedSignatureVenue = {
      ...homePagePayload.signatureVenue,
      name: formatAmpersand(homePagePayload.signatureVenue.name),
    };
    return {
      ...homePagePayload,
      hero: updatedHeroList,
      curatedVenues: updatedCuratedVenues,
      signatureVenue: updatedSignatureVenue,
    };
  } catch (error) {
    console.error(error);
    return homePagePayload;
  }
};
